import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";

const content = {
  en: {
    title: "Sources & methodology",
    body: [
      "BibleVoice presents the complete Ethiopian Orthodox broader canon \u2014 all 93 books \u2014 including the protocanon, the deuterocanonical books, and the wider Ethiopian canon such as 1 Enoch, Jubilees, 4 Baruch, the books of Meqabyan, the Didascalia, and the Books of the Covenant.",
      "English scripture is drawn primarily from the Berean Standard Bible (BSB), which is in the public domain. Additional translations are used where the BSB does not cover a given book, all sourced from public-domain and openly-licensed texts.",
      "The AI guide is shaped by Scripture and is designed to point you to God \u2014 never to replace Him, His Spirit, or His Church. It is a companion for study and encouragement, not a substitute for a community of faith.",
    ],
  },
  fr: {
    title: "Sources et m\u00e9thodologie",
    body: [
      "BibleVoice pr\u00e9sente le canon orthodoxe \u00e9thiopien complet \u2014 les 93 livres \u2014 incluant le protocanon, les livres deut\u00e9rocanoniques et le canon \u00e9thiopien plus large tel que 1 H\u00e9noch, les Jubil\u00e9s, 4 Baruch, les livres de Meqabyan, la Didascalie et les Livres de l\u2019Alliance.",
      "Le texte anglais provient principalement de la Berean Standard Bible (BSB), dans le domaine public. D\u2019autres traductions sont utilis\u00e9es l\u00e0 o\u00f9 la BSB ne couvre pas un livre donn\u00e9.",
      "Le guide IA est fa\u00e7onn\u00e9 par les \u00c9critures et con\u00e7u pour vous orienter vers Dieu \u2014 jamais pour Le remplacer, ni Son Esprit, ni Son \u00c9glise.",
    ],
  },
  es: {
    title: "Fuentes y metodolog\u00eda",
    body: [
      "BibleVoice presenta el canon ortodoxo et\u00edope completo \u2014 los 93 libros \u2014 incluyendo el protocanon, los libros deuterocan\u00f3nicos y el canon et\u00edope m\u00e1s amplio como 1 Enoc, Jubileos, 4 Baruc, los libros de Meqabyan, la Didascalia y los Libros del Pacto.",
      "El texto en ingl\u00e9s proviene principalmente de la Berean Standard Bible (BSB), de dominio p\u00fablico. Se usan otras traducciones donde la BSB no cubre un libro determinado.",
      "El gu\u00eda IA est\u00e1 formado por las Escrituras y dise\u00f1ado para se\u00f1alarte a Dios \u2014 nunca para reemplazarlo a \u00c9l, a Su Esp\u00edritu o a Su Iglesia.",
    ],
  },
};

export default function Provenance() {
  const { lang } = useApp();
  const c = content[lang] || content.en;
  return (
    <div className="relative z-10 min-h-screen flex flex-col items-center px-4 py-12">
      <div className="w-full max-w-2xl">
        <Logo size="md" />
        <Link to="/" className="mt-6 inline-flex items-center gap-2 text-sm text-[var(--gold-deep)] hover:underline">
          <ArrowLeft size={16} /> {t(lang, "backHome")}
        </Link>
        <div className="glass-strong rounded-3xl p-8 md:p-10 mt-4 fade-up">
          <h1 className="font-display text-4xl font-semibold text-[var(--ink)] mb-6">{c.title}</h1>
          <div className="space-y-5 font-scripture text-lg leading-relaxed text-[var(--ink-soft)]">
            {c.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
